import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <h3>Zanify Technologies</h3>
            <p>Digital Innovation, Crafted in Nairobi. We build powerful digital solutions that drive growth for businesses across Africa.</p>
          </div>
          <div className="footer-column">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/portfolio">Our Work</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h3>Services</h3>
            <ul className="footer-links">
              <li><Link to="/services">Mobile App Development</Link></li>
              <li><Link to="/services">Web Applications</Link></li>
              <li><Link to="/services">Website Development</Link></li>
              <li><Link to="/services">UI/UX Design</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h3>Connect With Us</h3>
            <div className="social-links">
              <a href="#"><i className="fab fa-linkedin-in"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
              <a href="#"><i className="fab fa-facebook-f"></i></a>
              <a href="#"><i className="fab fa-instagram"></i></a>
            </div>
            <div className="contact-info" style={{marginTop: '20px'}}>
              <p><i className="fas fa-envelope"></i> hello@zanifytech.com</p>
              <p><i className="fas fa-phone"></i> +254 705 653 953</p>
              <p><i className="fas fa-map-marker-alt"></i> Nairobi, Kenya</p>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>&copy; {currentYear} Zanify Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;